const messages = {
  releaseDatePrefix: 'gepostet am',
}

export default messages
